<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRuntimeStore } from '../stores/runtime'

const store = useRuntimeStore()
const state = computed(() => store.bootstrapState)
const payload = computed(() => state.value?.payload || {})
const sdkAdmin = ref(false)
const isAdmin = computed(() => Boolean(payload.value.is_admin) || sdkAdmin.value)

onMounted(() => {
  if (window.BX24?.init) {
    window.BX24.init(() => { sdkAdmin.value = Boolean(window.BX24?.isAdmin?.()) })
  }
})
const domain = computed(() => String(payload.value.domain || 'Bitrix24'))
</script>

<template>
  <div class="center-card setup-card">
    <h1>S-A-S Forms</h1>
    <p class="status-ok">Приложение установлено.</p>
    <div class="setup-step">
      <div class="step-number">1</div>
      <div>
        <strong>Bitrix24 авторизован</strong>
        <div class="muted">{{ domain }}</div>
      </div>
    </div>
    <div class="setup-step">
      <div class="step-number">2</div>
      <div>
        <strong>Связать с рабочим пространством S-A-S</strong>
        <p v-if="isAdmin">Откройте S-A-S Forms в новой вкладке, войдите в аккаунт и выберите Workspace.</p>
        <p v-else>Администратору Bitrix24 необходимо завершить подключение сервиса.</p>
        <a
          v-if="isAdmin && state?.link_url"
          class="button primary"
          :href="state.link_url"
          target="_blank"
          rel="noopener"
        >Связать с S-A-S Forms</a>
      </div>
    </div>
    <p class="muted">После завершения связи просто откройте приложение Bitrix24 ещё раз.</p>
  </div>
</template>
